/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  ProjectKpiFragmentDoc,
  UserKpiFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectKpiQueryVariables = Exact<{ [key: string]: never }>

export type ProjectKpiQuery = {
  __typename: "Query"
  projectKpi?: {
    __typename: "ProjectKpi"
    id: string
    projectsCount: {
      __typename: "ProjectsCount"
      total: number
      dailyOverview?: {
        __typename: "ProjectsDailyOverview"
        last7: number
        last30: number
      } | null
    }
  } | null
}

export type UserKpiQueryVariables = Exact<{ [key: string]: never }>

export type UserKpiQuery = {
  __typename: "Query"
  userKpi?: {
    __typename: "UserKpi"
    id: string
    usersCount: {
      __typename: "UsersCount"
      total: number
      internal: number
      external: number
    }
    registrations: {
      __typename: "Registrations"
      total: number
      linkedin: number
      microsoft: number
      google: number
      email: number
    }
    activeUsers: { __typename: "ActiveUsers"; external: number }
    dailyOverview: {
      __typename: "UsersDailyOverview"
      external: {
        __typename: "ExternalUsersDailyOverview"
        last7: {
          __typename: "ExternalUsersDailyOverviewLastDays"
          logins: number
          signups: number
        }
        last30: {
          __typename: "ExternalUsersDailyOverviewLastDays"
          logins: number
          signups: number
        }
      }
    }
  } | null
}

export const ProjectKpiDocument = gql`
  query ProjectKpi {
    projectKpi @rest(type: "ProjectKpi", endpoint: "kpi", path: "/projects") {
      ...ProjectKpi
    }
  }
  ${ProjectKpiFragmentDoc}
`

/**
 * __useProjectKpiQuery__
 *
 * To run a query within a React component, call `useProjectKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectKpiQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectKpiQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProjectKpiQuery,
    ProjectKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectKpiQuery, ProjectKpiQueryVariables>(
    ProjectKpiDocument,
    options
  )
}
export function useProjectKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectKpiQuery,
    ProjectKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectKpiQuery, ProjectKpiQueryVariables>(
    ProjectKpiDocument,
    options
  )
}
// @ts-ignore
export function useProjectKpiSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectKpiQuery,
    ProjectKpiQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProjectKpiQuery, ProjectKpiQueryVariables>
export function useProjectKpiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectKpiQuery, ProjectKpiQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ProjectKpiQuery | undefined,
  ProjectKpiQueryVariables
>
export function useProjectKpiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectKpiQuery, ProjectKpiQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProjectKpiQuery, ProjectKpiQueryVariables>(
    ProjectKpiDocument,
    options
  )
}
export type ProjectKpiQueryHookResult = ReturnType<typeof useProjectKpiQuery>
export type ProjectKpiLazyQueryHookResult = ReturnType<
  typeof useProjectKpiLazyQuery
>
export type ProjectKpiSuspenseQueryHookResult = ReturnType<
  typeof useProjectKpiSuspenseQuery
>
export type ProjectKpiQueryResult = Apollo.QueryResult<
  ProjectKpiQuery,
  ProjectKpiQueryVariables
>
export const UserKpiDocument = gql`
  query UserKpi {
    userKpi @rest(type: "UserKpi", endpoint: "kpi", path: "/users") {
      ...UserKpi
    }
  }
  ${UserKpiFragmentDoc}
`

/**
 * __useUserKpiQuery__
 *
 * To run a query within a React component, call `useUserKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserKpiQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserKpiQuery(
  baseOptions?: Apollo.QueryHookOptions<UserKpiQuery, UserKpiQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserKpiQuery, UserKpiQueryVariables>(
    UserKpiDocument,
    options
  )
}
export function useUserKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserKpiQuery, UserKpiQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserKpiQuery, UserKpiQueryVariables>(
    UserKpiDocument,
    options
  )
}
// @ts-ignore
export function useUserKpiSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserKpiQuery,
    UserKpiQueryVariables
  >
): Apollo.UseSuspenseQueryResult<UserKpiQuery, UserKpiQueryVariables>
export function useUserKpiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserKpiQuery, UserKpiQueryVariables>
): Apollo.UseSuspenseQueryResult<
  UserKpiQuery | undefined,
  UserKpiQueryVariables
>
export function useUserKpiSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserKpiQuery, UserKpiQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserKpiQuery, UserKpiQueryVariables>(
    UserKpiDocument,
    options
  )
}
export type UserKpiQueryHookResult = ReturnType<typeof useUserKpiQuery>
export type UserKpiLazyQueryHookResult = ReturnType<typeof useUserKpiLazyQuery>
export type UserKpiSuspenseQueryHookResult = ReturnType<
  typeof useUserKpiSuspenseQuery
>
export type UserKpiQueryResult = Apollo.QueryResult<
  UserKpiQuery,
  UserKpiQueryVariables
>
